<div class="container-fluid">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a href="#/panel-admin"class="btn btn-primary">
                Volver
              </a>
            </div>
            <h3 class="page-title">Inscripción | Aspirantes</h3>
        </div>
    </div>
  </div>

  <div class="row" style="overflow-x: scroll;">
    <div class="col-12">
        <div class="card" style="border-color: white;">
          <div class="card-body" style="margin-bottom: 150px;">
            <!-- Invoice Logo-->
            <div class="row">
              <div class="col-md-6">
                <label for="estadol" class="col-form-label">Busqueda</label>
                <input
                  class="form-control"
                  type="text"
                  id="buscar"
                  placeholder="Buscar estudiante..."
                  [(ngModel)]="searchTerm"
                  (input)="buscarAccionFormativa()"
                >
              </div>
              <ng-content *ngIf="user.id_rol == 12 || user.id_rol == 20">
                <div class="col-md-6">
                  <label for="estadol" class="col-form-label">Estado</label>
                  <select class="form-select" id="estado" name="estado" (change)="consulta_combos()">
                    <option *ngFor="let ed of estado" [value]="ed.id_estado" [selected]="ed.id_estado == sel_edo ? true : false">
                      {{ed.nombre}}
                    </option>
                  </select>
                </div>
              </ng-content>


            </div>
            <hr class="text-dark">
            <div class="row">
              <div class="col-12">
                <table class="table">
                  <thead>
                    <tr class="table-primary">
                      <th scope="col">N°</th>
                      <th scope="col">Cedula</th>
                      <th scope="col">Nombre(s) y Apellido(s)</th>
                      <th scope="col">Pre-Impreso</th>
                      <th scope="col">Ocupación</th>
                      <th scope="col">Organización</th>
                      <th scope="col">Estado</th>
                      <th scope="col">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="checkboxMaster"
                            [(ngModel)]="selectAll"
                            (change)="seleccionaTodo()"
                            style="font-size: 22px; border: 3px solid #313131;">
                          <label class="form-check-label" for="checkboxMaster">
                            Marcar Todos
                          </label>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let r of filteredResultado; let i = index;">
                      <th scope="row">{{i+1}}</th>
                      <td>{{r.identificacion}}</td>
                      <td>{{r.nombre_full}}</td>
                      <td>{{r.pre_impreso}}</td>
                      <td>{{r.ocupacion}}</td>
                      <td>{{r.organizacion}}</td>
                      <td>{{r.estado}}</td>
                      <td>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="checkbox-{{i}}"
                            [(ngModel)]="r.esSeleccion"
                            (change)="seleccionaUno(r)"
                            style="font-size: 20px; border: 3px solid #313131;">
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row mt-3" *ngIf="validador">
              <div class="col-12 text-center">
                <button type="button" class="btn btn-lg btn-primary" (click)="confirmacion()">Inscribir Seleccionados</button>
              </div>
            </div>
          </div> <!-- end card-body-->
      </div> <!-- end card -->
    </div> <!-- end col-->
  </div>
  <!-- end row -->

</div>


<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje" (saveModal)="guardar_todo()"></app-modal>
